import debugLog from '@/debug-log-script-name.js'

$(function() {
  $('body').on('bless', function(e) {
    var $target = $(e.target)
    var $selects = $target.is('select') ? $target : $target.find('select')
    debugLog($selects, 'selectize.js') // DEBUG
    $selects.each(function() {
      var customOptions = {},
        selectizeOptions = {
          allowEmptyOption: true,
          copyClassesToDropdown: false,
          render: {
            option: function(item, escape) {
              var meta = item.meta ? item.meta : null,
                dataExtraValue = item.dataExtraValue ? item.dataExtraValue : null

              return (
                '<div ' +
                (dataExtraValue ? 'data-extra-value="' + escape(dataExtraValue) + '"' : '') +
                '>' +
                '<span class="label">' +
                escape(item.text) +
                '</span>' +
                (meta ? '<span class="meta">' + meta + '</span>' : '') +
                '</div>'
              )
            },
            item: function(data, escape) {
              return `<div class="item">${escape(data.text)} ${
                this.$input.attr('data-clearbutton')
                  ? '<button type="button" class="item__clear">x</button>'
                  : ''
              }</div>`
            },
          },
          onInitialize: function() {
            this.$wrapper.on('click', '.item__clear', () => this.clear())
          },
          searchField: ['text', 'meta'],
        },
        $select = $(this)

      if ($select.is('.no-selectize')) {
        return
      }

      customOptions.options = $select
        .find('option')
        .map(function() {
          var $option = $(this)

          if ($option.val()) {
            return {
              text: $option.text(),
              value: $option.val(),
              meta: $option.attr('data-meta'),
              email: $option.attr('data-email'),
              street: $option.attr('data-street'),
              housenumber: $option.attr('data-housenumber'),
              zipcode: $option.attr('data-zipcode'),
              city: $option.attr('data-city'),
              company: $option.attr('data-companyname'),
              color: $option.attr('data-color'),
              position: $option.attr('data-position'),
              dataExtraValue: $option.attr('data-extra-value'),
            }
          }
        })
        .toArray()

      if ($select.hasClass('select--add-customer')) {
        selectizeOptions = {
          onInitialize: function() {
            var s = this
            s.revertSettings.$children.each(function() {
              $.extend(s.options[this.value], $(this).data())
            })
          },
          render: {
            option: function(item, escape) {
              var meta = item.meta ? item.meta : null,
                street = ' data-street="' + item.street + '" ',
                housenumber = 'data-housenumber="' + item.housenumber + '" ',
                zipcode = 'data-zipcode="' + item.zipcode + '" ',
                city = 'data-city="' + item.city + '" ',
                companyname = 'data-companyname="' + item.companyname + '" ',
                dataExtraValue = item.dataExtraValue ? item.dataExtraValue : null

              return (
                '<div' +
                street +
                housenumber +
                zipcode +
                city +
                companyname +
                (dataExtraValue ? 'data-extra-value="' + escape(dataExtraValue) + '"' : '') +
                '>' +
                '<span class="label">' +
                escape(item.text) +
                '</span>' +
                (meta ? '<span class="meta">' + meta + '</span>' : '') +
                '</div>'
              )
            },
          },
        }
      }

      if ($select.hasClass('select--customer')) {
        var ajaxUrl = $select.data('ajaxurl')
        selectizeOptions = {
          create: false,
          copyClassesToDropdown: false,
          searchField: ['FullName', 'Email'],
          labelField: 'FullName',
          valueField: 'Key',
          options: [],
          onBlur: function() {
            var loaded_searches = $(this)[0].loadedSearches
            var email = Object.keys(loaded_searches).reverse()[0] || ''
            localStorage.email = email
            $('input[type="email"]').val(localStorage.email)
            $('#customer-key-selectized').val(localStorage.email)
          },

          render: {
            option: function(item, escape) {
              return (
                '<div><span class="label">' +
                escape(item.FullName) +
                '</span><span class="meta">' +
                escape(item.Email) +
                '</span></div>'
              )
            },
          },
          onChange: function(value) {
            const item = this.$input[0]
            const selectedText = $(item.selectize.getItem(value)[0]).text()

            if (selectedText) {
              $('.modal .button--confirm').prop('disabled', false)
            } else {
              $('.modal .button--confirm').prop('disabled', true)
            }

            const selectizeData = this.options[value]
            const emails = $.map($('.email'), function(value) {
              return value.innerText
            })

            if (!!selectizeData && jQuery.inArray(selectizeData.Email, emails) != '-1') {
              $('.modal .button--confirm').prop('disabled', true)
            } else {
              $('.modal .button--confirm').prop('disabled', false)
            }
          },
          load: function(query, callback) {
            if (!query.length) return callback()
            $.ajax({
              url: ajaxUrl,
              type: 'GET',
              data: {
                q: query,
              },
              error: function() {
                callback()
              },
              success: function(data) {
                callback(data)
              },
            })
          },
        }
      }

      // Selectize color selector
      if ($select.hasClass('select--colors')) {
        customOptions.render = {}

        customOptions.render.option = function(item, escape) {
          var color = item.color ? item.color : null

          return (
            '<div>' +
            '<span class="select__option-color" style="background: ' +
            color +
            ';"></span>' +
            '<span class="label">' +
            escape(item.text) +
            '</span>' +
            '</div>'
          )
        }

        customOptions.render.item = function(item, escape) {
          var color = item.color ? item.color : null

          return (
            '<div class="item item--color"><span class="select__item-color" style="background: ' +
            color +
            ';"></span>' +
            escape(item.text) +
            '</div>'
          )
        }
      }

      if ($select.hasClass('select--deals') || $select.hasClass('select--products')) {
        $select.selectize($.extend(selectizeOptions, customOptions))
      } else {
        $select.selectize($.extend({ plugins: ['remove_button'] }, selectizeOptions, customOptions))
      }
    })

    var items = []

    const select_options =
      $('select') &&
      $('select').data() &&
      $('select').data().selectize &&
      $('select').data().selectize.options

    $(select_options).each(function(i, e) {
      items.push($(e))
    })

    $(document).on('change', '.form-element[name="CustomerKey"]', function(e) {
      var current_value = e.currentTarget.value
      if (items.length === 0) {
        return
      }
      var selectize_id = items[0][0][current_value]
      if (selectize_id) {
        var street = selectize_id.street ? selectize_id.street : ''
        var email = selectize_id.email ? selectize_id.email : ''
        var zipcode = selectize_id.zipcode ? selectize_id.zipcode : ''
        var city = selectize_id.city ? selectize_id.city : ''
        var companyname = selectize_id.companyname

        $('input[name="CompanyEmail"]').val(email)
        $('input[name="CompanyAddress"]').val(street)
        $('input[name="CompanyZipcode"]').val(zipcode)
        $('input[name="CompanyCity"]').val(city)
        $('input[name="CompanyName"]').val(companyname)

        // APP-1940 - Hide the country field in this situation, will be replaced soon
        $('input[name="CompanyCountryCode"]')
          .parent()
          .hide()
      }
    })
  })
})
